// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"670e15c7","967":"3e51d3fc"}[chunkId] + ".chunk.js";
};